module.exports = __webpack_public_path__ + "img/158.1915baea.jpg";